<template>
  <div id="dialogWrap">

    <QrDialog
      ref="qrDialog"
      title="重置登录密码二维码"
      :url="url"
      content="请使用手机扫码进行登录密码修改"
    />

  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
import QrDialog from './qrDialog.vue'
export default {
  components: {
    QrDialog
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      url: '',
      url1: '',
      baseUrl: window.g.APP_PATH_mobile,
      openStatus: false,
      isSign: false,
      bankId: null,
      loginPwd: true,
      dialogVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter'])
  },
  mounted() {
    if (this.sessionInfoGetter.isLogin == 'true') {
      this.getSessionKey2()
    }
  },
  methods: {
    // 得到秘钥 --- 修改登录
    getSessionKey2() {
      http
        .getRes(protocol.param_getSessionKey2)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
            console.log(this.url)
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#dialogWrap {
  z-index: 9999;
  padding:40px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F4F4F4;
  /deep/.dialog-footer{
    margin-top:20px;
    color:#333333;
  }
}
</style>
